import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_zm8abz448x: FaireCollectionEntity = {
  token: "pbc_zm8abz448x",
  type: "collection",
  name: "Your Fave Fit: Tummy Control ",
  heroImageUrl:
    "https://cdn.faire.com/fastly/31d0192328ca9d9b9e6a380ce626d3531d1a303320f21946b02334bb312fa52f.jpeg",
  itemCount: 48,
  description:
    "Known and loved for a reason—Judy Blue’s tummy control styles offer the perfect combo of structure and stretch. Part of the brands original DNA, the Tummy Control technology used specialty\npocketing sewn expertly inside the front of the jeans to keep your shape the way you want.",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:16.024Z",
    importedBy: "entity-db-import-collections",
  },
};
